<div class="pricelist-online-product" *ngIf="dataSource?.length > 0">
  <h3>{{ tableTitle }}</h3>

  <p-table [value]="priceList">
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th>{{ tableTitle === 'Individuals' ? 'Weekly Prices' : 'Per Lesson' }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <tr>
        <td>{{ data.name }}</td>
        <td>
          <div *ngIf="data?.prices.length > 0; else noData">
            <ng-container *ngFor="let price of data?.prices; last as isLast">
              <span> {{ price.currency }}{{ price.value }} </span>
              <ng-container *ngIf="!isLast">/</ng-container>
            </ng-container>
          </div>
          <ng-template #noData> N/A </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
